module.exports = __webpack_public_path__ + "static/media/language.d4f7a972.svg";